<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SelectContainerInfo')"
    width="800px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>gridApi=params.api"
    />
    <span slot="footer">
      <el-button type="primary" @click="saveHandler">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { queryByUnTruckingInfo, updateContaierUsageLinkedTruckingInfo } from '@/api/seaExport/containerUsage'

export default {
  name: 'TruckingContainerUsageLinkDialog',
  components: { },
  props: {
    modifyUsageInEditMode: { type: Boolean, default: false },
    data: { type: Array, default: () => [] },
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: false },
    truckingInfoUuid: { type: String, required: false }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'uuid',
          width: 70,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'eqSize')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'uuid',
          width: 70,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'eqType')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerNo')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerWeight')
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'sealNo')
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 70,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'weight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      selectedData: {}
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.queryHandler()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.queryHandler()
    }
  },
  methods: {
    queryHandler() {
      if (this.modifyUsageInEditMode) {
        this.rowData = this.data
      } else {
        queryByUnTruckingInfo({ jobUuid: this.jobUuid }).then(res => {
          this.rowData = res.data
        })
      }
    },
    saveHandler() {
      const selUsages = this.gridApi.getSelectedRows()
      if (selUsages.length === 0) {
        return
      }
      if (this.modifyUsageInEditMode) {
        this.innerVisible = false
        this.$emit('selectContainerUsageHandler', selUsages)
      } else {
        const keysList = []
        for (const usage of selUsages) {
          keysList.push(usage.uuid)
        }
        const params =
          {
            truckingInfoId: this.truckingInfoUuid,
            usageIds: keysList
          }
        updateContaierUsageLinkedTruckingInfo(params).then(() => {
          this.innerVisible = false
          this.$emit('selectContainerUsageHandler', this.selectedData)
          this.$emit('saveContainerUsageData', params)
        })
      }
    }
  }
}
</script>

<style>
</style>
